import { DEFAULT_DASHBOARD_NOT_FOUND_MSG } from "@const/dashboard.constants";
import { BasicResponseDTO } from "@dto/basicResponse.dto";
import { AxiosError } from "axios";
import { API_URL } from "src/data/Api";
import { RoutePath } from "src/data/Routes";
import { NavDomain } from "./NavDomain";

export const dashboardDomain: NavDomain = {
  matches: clsPath => clsPath === RoutePath.DASHBOARD,

  pathUrl: itemSearch => itemSearch === RoutePath.DEFAULT
    ? API_URL.DASHBOARD + RoutePath.DEFAULT
    : API_URL.DASHBOARD_MENU + RoutePath.GET_PATH + itemSearch,

  /**
   * Falls back to the default dashboard when the requested one no longer exists. Any menu
   * get-path failure bounces; the default dashboard request itself only on its own message,
   * so a plain outage there does not redirect to the route that just failed.
   */
  loadErrorFallback(reason: AxiosError<BasicResponseDTO>, urlGetPath: string): RoutePath | undefined {
    if (reason.response?.data?.message === DEFAULT_DASHBOARD_NOT_FOUND_MSG
      || !urlGetPath.endsWith(RoutePath.DEFAULT)) {
      return RoutePath.DASHBOARD;
    }
  },
};
